import { jsx as e, jsxs as o } from "react/jsx-runtime";
import { Close as d } from "@mui/icons-material";
import { Dialog as p, DialogContent as h, Toolbar as g, IconButton as f, Typography as u } from "@mui/material";
import { makeStyles as y } from "tss-react/mui";
import N from "./DialogBase.style.js";
const C = y()(N), j = ({
  open: t,
  title: s,
  fullScreen: l,
  hideAppBar: i,
  dataTestid: c = "Lumi-dialog",
  className: n,
  children: m,
  onClose: r
}) => {
  const { classes: a } = C();
  return /* @__PURE__ */ e(
    p,
    {
      fullScreen: l,
      open: t,
      onClose: r,
      classes: {
        scrollPaper: l ? a.scrollPaper : null,
        paper: n
      },
      "data-testid": c,
      children: /* @__PURE__ */ o(h, { className: a.mainWrapper, children: [
        !i && /* @__PURE__ */ o(g, { className: a.headerContent, children: [
          /* @__PURE__ */ e(
            f,
            {
              "aria-label": "close",
              edge: "start",
              size: "small",
              "data-testid": "dialogCloseBtn",
              className: a.closeIcon,
              onClick: r,
              children: /* @__PURE__ */ e(d, {})
            }
          ),
          s && /* @__PURE__ */ e("div", { className: a.titleWrapper, children: /* @__PURE__ */ e(u, { variant: "h6", className: a.headerTitle, children: s }) })
        ] }),
        m
      ] })
    }
  );
};
export {
  j as default
};
